import { flagFactory } from '../icon';
import Svg from './sk.svg';

export default flagFactory(Svg);
